<template>
  <div class="width-100" style="height: 7vh">
    <div style="height: 7vh" class="width-100 bg-white" :class="mobileMode ? '' : 'flex-row justify-content-center align-items-center'">
      <div style="height: 7vh" class="main tab width-100" :class="mobileMode ? '' : 'flex-row justify-content-spaceBetween align-items-center'">
        <div class="width-30" :class="mobileMode ? 'flex-row justify-content-spaceBetween align-items-center width-100' : ''">
          <img class="from-bottom1 height72" src="@/assets/image/logo2.0.png" @click="jumpTo('/')" alt="" />
          <!--          <i @click="switchMenu" class="el-icon-s-fold margin-r fs-sBig myBlue"></i>-->
        </div>
        <!--        <p>{{ radio + ' - ' + windowScreenWidth }}</p>-->
        <div class="width-70" :class="mobileMode ? '' : 'flex-row justify-content-end align-items-center'">
          <el-menu
            :style="openMenu ? 'display: none' : ''"
            :default-active="selectTab"
            active-text-color="rgb(11,73,158)"
            class="el-menu-demo"
            :class="mobileMode ? '' : 'flex-row justify-content-end align-items-center'"
            mode="horizontal"
            @select="handleSelect"
          >
            <el-menu-item @click="jumpTo('/')" index="0">网站首页</el-menu-item>
            <el-submenu index="1">
              <template slot="title">集团概况</template>
              <el-menu-item @click="jumpTo('group', 0)" index="1-1">集团简介</el-menu-item>
              <el-menu-item @click="jumpTo('group', 1)" index="1-2">组织架构</el-menu-item>
              <el-menu-item @click="jumpTo('group', 2)" index="1-3">部室介绍</el-menu-item>
              <el-menu-item @click="jumpTo('group', 3)" index="1-4">发展历程</el-menu-item>
            </el-submenu>
            <el-submenu index="2">
              <template slot="title">新闻中心</template>
              <el-menu-item @click="jumpTo('news', 0)" index="2-1">集团动态</el-menu-item>
              <el-menu-item @click="jumpTo('news', 1)" index="2-2">辖属动态</el-menu-item>
              <el-menu-item @click="jumpTo('news', 2)" index="2-4">党群活动</el-menu-item>
            </el-submenu>
            <el-menu-item @click="jumpTo('/notice')" index="3">通知公告</el-menu-item>
            <el-submenu index="4">
              <template slot="title">下属企业</template>
              <el-menu-item @click="jumpTo('enterprise', 0)" index="4-1">全资及控股子公司</el-menu-item>
              <el-menu-item @click="jumpTo('enterprise', 1)" index="4-2">直管企业</el-menu-item>
              <el-menu-item @click="jumpTo('enterprise', 2)" index="4-3">参股企业</el-menu-item>
            </el-submenu>
            <el-menu-item @click="jumpTo('/profile')" index="5">投资项目</el-menu-item>
            <el-menu-item @click="jumpTo('/projectList')" index="6">专题专栏</el-menu-item>
            <el-menu-item @click="jumpTo('/submit')" index="7">廉政信箱</el-menu-item>
          </el-menu>
          <!--          <div class="search-block flex-row justify-content-center align-items-center">-->
          <!--            <i class="el-icon-search white fs-big"></i>-->
          <!--          </div>-->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import config from '@/config';

export default {
  name: 'Tabbar',
  components: {},
  props: {
    selectTab: {
      type: String
      // required: true,
      // animation2: Boolean
    }
  },
  data() {
    return {
      radio: null,
      windowScreenWidth: null,
      clientWidth: null,
      activeIndex: '1',
      offsetWidth: null,
      mobileMode: false,
      openMenu: false,
      widthLimit: config.widthLimit
    };
  },
  watch: {
    offsetWidth(val) {
      console.log(val);
      // this.mobileMode = val < this.widthLimit;
    }
  },
  mounted() {
    this.windowScreenWidth = window.screen.width;
    this.radio = window.devicePixelRatio;
    this.offsetWidth = document.body.offsetWidth;
    // this.mobileMode = this.offsetWidth < this.widthLimit;

    window.onresize = () => {
      return (() => {
        this.offsetWidth = document.body.offsetWidth;
      })();
    };
  },
  methods: {
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    jumpTo(e, m) {
      this.$router.push({ path: e, query: { Id: m } });
    },
    switchMenu() {
      this.openMenu = !this.openMenu;
    }
  },

  created() {
    // this.activeIndex=select
    // console.log(selectTab)
  }
};
</script>

<style lang="less" scoped>
.search-block {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: rgb(11, 73, 158);
}

.height72 {
  height: 72px;
}
</style>
<style>
.el-menu--horizontal > .el-menu-item {
  width: 120px;
  text-align: center;
  font-size: 18px;
}
.el-submenu,
.el-submenu__title,
.el-menu-item {
  font-size: 18px;
}
.el-menu--collapse .el-menu .el-submenu,
.el-menu--popup {
  min-width: 115px;
  text-align: center;
}
.el-menu.el-menu--horizontal {
  border-bottom: none;
}
</style>
